// src/composables/useButtonContext.ts
import { ref } from 'vue';
import { type ContextMenuItemGroup, type ContextMenuItem } from '@teamworksdev/vuetify';

interface ButtonContext {
  label: string;
  color?: string;
  variant?: 'primary' | 'secondary';
  icon?: string;
  action?: () => void;
  isContextMenu?: boolean;
  contextMenuItems?: ContextMenuItemGroup[] | ContextMenuItem[];
  hide?: boolean;
  loading?: boolean;
}
const buttonContext = ref<ButtonContext[]>([]);

const setButtonContext = (context: ButtonContext[]) => {
  buttonContext.value = context.map((button) => ({
    ...button,
    variant: button.variant ?? 'secondary',
    contextMenuItems: button.contextMenuItems ?? [],
  }));
};

const resetButtonContext = () => {
  buttonContext.value = [];
};

export function useHeaderButtonContext() {
  return {
    buttonContext,
    setButtonContext,
    resetButtonContext,
  };
}
